<!-- 详情信息 -->
<template>
  <div id='detail'>
    <p>{{title[index].value}}</p>
    <p class="content">{{detail[title[index].key]}}</p>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  props: {
    detail: Object,
    title: Array,
    index: Number
  },
  components: {},
  created () {},
  methods: {}
}
</script>
<style scoped lang='scss'>
#detail{
  display: flex;
  justify-content: space-between;
  height: 53px;
  border-bottom: 1px solid rgba(239,242,245,1);
  color: #888D9D;
  p{
    margin-top: 30px;
    margin-left: 20px;
    &.content{
      color: #333;
      margin-right: 20px;
    }
  }
}
</style>
